var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLinkedin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93994 4.99996C6.93968 5.5304 6.72871 6.039 6.35345 6.41388C5.97819 6.78877 5.46937 6.99923 4.93894 6.99896C4.40851 6.9987 3.89991 6.78773 3.52502 6.41247C3.15014 6.03721 2.93968 5.5284 2.93994 4.99796C2.94021 4.46753 3.15117 3.95893 3.52644 3.58404C3.9017 3.20916 4.41051 2.9987 4.94094 2.99896C5.47137 2.99923 5.97998 3.2102 6.35486 3.58546C6.72975 3.96072 6.94021 4.46953 6.93994 4.99996V4.99996ZM6.99994 8.47996H2.99994V21H6.99994V8.47996ZM13.3199 8.47996H9.33994V21H13.2799V14.43C13.2799 10.77 18.0499 10.43 18.0499 14.43V21H21.9999V13.07C21.9999 6.89996 14.9399 7.12996 13.2799 10.16L13.3199 8.47996V8.47996Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Linkedin.76cdd826.svg";
export { ForwardRef as ReactComponent };